export default "__VITE_ASSET__5b7acee5__"